module.exports = __webpack_public_path__ + "media/img/calendar/google-1966f926eabab0616778ff0d0c655e83.png";